import httpClient from "http-client/http-client";

const BASE = "v1/community-portal/service-account";

export async function getServiceAccount(accountId) {
  const params = accountId ? { account_id: accountId } : {};
  const { data, errors } = await httpClient.get({ url: BASE, params });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

/**
 * Partial update (JWT resolves account). Body per BFF `patchServiceAccountSchema`.
 * @param {Record<string, unknown>} body
 */
export async function patchServiceAccount(body) {
  const { data, errors } = await httpClient.patch({ url: BASE, body });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}
